  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>医药公司筛选</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <Visualization v-show="nowIndex===0"></Visualization>
    <!-- 数据列表 -->
    <div class="dataList" v-show="nowIndex===1">
      <!-- 查询 -->
      <div class="rightTop">
        <div class="title">
          <img src="@/assets/img/14.png" alt />
          <span>筛选条件</span>
        </div>
        <div class="con">
          <div class="conLeft1">
            <!-- one -->
            <div class="selectBox">
              <span>时间</span>
              <el-select
                v-model="selectTime.value"
                multiple
                collapse-tags
                placeholder="请选择"
                @change="selectOne"
              >
                <el-option
                  v-for="item in selectTime.timeList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <!-- two -->
            <div class="selectBox addLength">
              <span>品种</span>
              <el-select
                v-model="selectType.value"
                multiple
                collapse-tags
                placeholder="请选择"
                @change="selectTwo"
              >
                <el-option
                  v-for="item in selectType.typeList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>

            <!-- 输入 one-->
            <div class="selectBox three">
              <span>产品名称</span>
              <el-input placeholder="请输入产品名称" v-model="input1" clearable @change="inputOne"></el-input>
            </div>
          </div>
          <div class="conLeft2">
            <!--  two-->
            <div class="selectBox">
              <span>生产单位</span>
              <el-input placeholder="请输入生产单位" v-model="input2" clearable @change="inputTwo"></el-input>
            </div>
            <div class="button" @click="searchFun">查询</div>
          </div>
        </div>
      </div>
      <!--下载 -->
      <div class="rightCenter">
        <div class="centerTit">化学原料药二十四大类品种产量、出口量</div>
        <div class="centerCon">
          <div class="no">
            <span></span>
          </div>
          <div class="cueWords" v-show="hint">最多下载1000条</div>

          <div class="excel" @click="downloadTable()" @mouseenter="enter()" @mouseleave="leave()">
            <img src="@/assets/img/Excel.png" alt />
            下载数据到Excel
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rightBottom">
        <div class="tabulationBottom">
          <el-table
            :data="tableList"
            style="width: 100%"
            border
            size="mini"
            :cell-style="cellStyle3"
            @row-click="getDetails3"
          >
            <af-table-column prop="time" fixed label="时间"></af-table-column>
            <af-table-column prop="type" fixed label="品种"></af-table-column>
            <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
            <af-table-column prop="department" fixed label="生产单位"></af-table-column>
            <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
            <af-table-column prop="output" label="产量(吨)"></af-table-column>
            <af-table-column prop="export" label="出口量(吨)"></af-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="rightPaging">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totlalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import Visualization from "@/components/visualization.vue";

export default {
  props: {},
  components: {
    Visualization
  },
  data() {
    return {
      nowIndex: 1,

      times: "",
      types: "",
      productNames: "",
      department: "",
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      currentPage4: 1,
      totlalCount: 0, //总条数

      // 选择框
      selectTime: {
        timeList: [],
        value: []
      },

      selectType: {
        typeList: [],
        value: []
      },

      input1: "",
      input2: "",
      tableList: [],
      // 下载提示
      hint: false
    };
  },
  computed: {},
  methods: {
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    },
    //查询
    selectOne(val) {
      this.times = val.toString();
      // console.log(this.times, 999999999999);
      this.getTableData(
        this.times,
        this.types,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    selectTwo(val) {
      this.types = val.toString();
      // console.log(this.types, 999999999999);
      this.getTableData(
        this.times,
        this.types,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },

    inputOne() {
      // console.log(this.input1, 33333333333);
      this.productNames = this.input1;
      this.getTableData(
        this.times,
        this.types,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    inputTwo() {
      // console.log(this.input2, 33333333333);
      this.department = this.input2;
      this.getTableData(
        this.times,
        this.types,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    searchFun() {
      let _this = this;
      magic.loginOrRights(1).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("请您购买！");
          return;
        }
        _this.productNames = _this.input1;
        _this.department = _this.input2;
        _this.getTableData(
          _this.times,
          _this.types,
          _this.productNames,
          _this.department,
          _this.offset,
          _this.limit
        );
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 获取时间
    getTime() {
      api.pharmaTwentyFourTime().then(res => {
        this.selectTime.timeList = res.data;
        // console.log(res.data, "time");
      });
    },
    // 获取品种
    getTypes() {
      api.pharmaTwentyFourType().then(res => {
        this.selectType.typeList = res.data;
        // console.log(res.data, "type");
      });
    },

    // 分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getTableData(
        this.times,
        this.types,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
    },
    // 表格数据
    getTableData(times, types, productNames, department, offset, limit) {
      //  {	 "times":"2016,2015", "types":"十八、五富科用药,五、计划生育用药","productNames":"","department":"","offset":0,"limit":10}
      let parmars = {
        times,
        types,
        productNames,
        department,
        offset,
        limit
      };
      api.pharmaTwentyFourTable(parmars).then(res => {
        this.totlalCount = res.data.total;
        this.tableList = res.data.rows;
        // console.log(res.data, "表格数据");
      });
    },
    // 公司高亮
    cellStyle3({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return `color:#3583ED;font-weight:bold;cursor: pointer;`;
      } else {
        return "";
      }
    },
    // 去搜索页
    getDetails3(row, column) {
      if (column.property == "department") {
        let companyName = row.department;
        let entId = row.uniqueCode;
        let dbcode = this.$route.query.dbcode;
          if (entId != "***" && entId != "--") {
          this.$router.push({
            path: `/enterprisesDetail`,
            query: {
              entId
            }
          });
        } else {
          this.$message.error("暂无数据!");
        }
        sessionStorage.setItem("companyName", JSON.stringify(companyName));
      }
    },
    // 下载
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    downloadTable() {
      magic.loginOrRights(1).then(res => {
        if (!res) {
          this.$message.error("请您登录！");
        } else {
          api.weighterRights(1).then(res => {
            if (res.data) {
              axios({
                method: "post",
                url:
                  window.medicineUrl + "/medicineSearch/downEnterprise24Data", // 请求地址
                data: {
                  times: this.times,
                  types: this.types,
                  productNames: this.productNames,
                  department: this.department,
                  offset: this.offset,
                  limit: this.limit
                },
                responseType: "arraybuffer",
                observe: "response"
              }).then(res => {
                const fileName = "化学原料药二十四大类品种产量、出口量.xlsx";
                let blob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              });
              // 埋点
              try {
                //LogCollection.contents["key"]="value";
                //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                //2：收藏
                //3：下载
                //4：分享
                //5：购买
                //6：登录
                //7：注册
                //9：搜索
                //10：复制
                //11：点赞
                //12：评论
                LogCollection.send(3);
              } catch (e) {}
            } else {
              this.$message.error("请您购买！");
            }
          });
        }
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");

      document.body.appendChild(link);
      link.click();
    }
  },
  created() {},
  mounted() {
    this.getTime(); //时间
    this.getTypes(); //品种
    this.getTableData(
      this.times,
      this.types,
      this.productNames,
      this.department,
      this.offset,
      this.limit
    ); //表格
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
.addLength .el-select {
  width: 370px !important;
}
</style>


// WEBPACK FOOTER //
// src/view/pharma/twentyFour.vue